
export function getComponent(name) {
  const [section, ...componentPath] = name.split('.');
  const componentName = componentPath.join('.');
  return new Promise( (resolve, reject) => {
    if (0 == componentName.length || 0 == section.length) { reject("invalid component's name"); return; }
    if (false) {
    } else if ("advanced" == section) {
      const components = {
        'autocomplete': require('./components/advanced/autocomplete').default
       ,'colorComplex': require('./components/advanced/color-complex').default
       ,'colorPalette': require('./components/advanced/color-palette').default
       ,'colorPickerPopup': require('./components/advanced/color-picker-popup').default
       ,'colorPicker': require('./components/advanced/color-picker').default
       ,'dateRangePicker': require('./components/advanced/date-range-picker').default
       ,'dateTimePicker': require('./components/advanced/date-time-picker').default
       ,'imageGallery': require('./components/advanced/image-gallery').default
       ,'pagination': require('./components/advanced/pagination').default
       ,'rangeSlider': require('./components/advanced/range-slider').default
       ,'richTextCounter': require('./components/advanced/rich-text-counter').default
       ,'richText': require('./components/advanced/rich-text').default
       ,'slider': require('./components/advanced/slider').default
       ,'surveyAddonEstimator': require('./components/advanced/survey-addon-estimator').default
       ,'surveyEstimator': require('./components/advanced/survey-estimator').default
       ,'tabbedSidebar': require('./components/advanced/tabbed-sidebar').default
       ,'tagsList': require('./components/advanced/tags-list').default
       ,'toggle': require('./components/advanced/toggle').default
       ,'tutorialVideoList': require('./components/advanced/tutorial-video-list').default
       ,'tutorialVideo': require('./components/advanced/tutorial-video').default
        };
      if (null != components[componentName]) resolve(components[componentName]);
      else reject("invalid component's name");
    } else if ("assets" == section) {
      const components = {
        'assetFilesUploader': require('./components/assets/asset-files-uploader').default
       ,'uploadAssetsButton': require('./components/assets/upload-assets-button').default
        };
      if (null != components[componentName]) resolve(components[componentName]);
      else reject("invalid component's name");
    } else if ("basic" == section) {
      const components = {
        'autosizedInput': require('./components/basic/autosized-input').default
       ,'button': require('./components/basic/button').default
       ,'checkBox': require('./components/basic/check-box').default
       ,'clickOutside': require('./components/basic/click-outside').default
       ,'clickTarget': require('./components/basic/click-target').default
       ,'clickTarget.test': require('./components/basic/click-target.test').default
       ,'dropdownMenu': require('./components/basic/dropdown-menu').default
       ,'dropdownMenu.test': require('./components/basic/dropdown-menu.test').default
       ,'dropdown': require('./components/basic/dropdown').default
       ,'formattedInput': require('./components/basic/formatted-input').default
       ,'hoverTarget': require('./components/basic/hover-target').default
       ,'imagePin': require('./components/basic/image-pin').default
       ,'imagePopup': require('./components/basic/image-popup').default
       ,'inlineSearch': require('./components/basic/inline-search').default
       ,'inlineSelect': require('./components/basic/inline-select').default
       ,'label': require('./components/basic/label').default
       ,'lightBox': require('./components/basic/light-box').default
       ,'loaderDots': require('./components/basic/loader-dots').default
       ,'loaderWave': require('./components/basic/loader-wave').default
       ,'maskedInput': require('./components/basic/masked-input').default
       ,'materialTextField': require('./components/basic/material-text-field').default
       ,'multiSelect': require('./components/basic/multi-select').default
       ,'pagination': require('./components/basic/pagination').default
       ,'popup': require('./components/basic/popup').default
       ,'portal': require('./components/basic/portal').default
       ,'radioButton': require('./components/basic/radio-button').default
       ,'rolldown': require('./components/basic/rolldown').default
       ,'scrollBar': require('./components/basic/scroll-bar').default
       ,'select': require('./components/basic/select').default
       ,'staticBlock': require('./components/basic/static-block').default
       ,'textField': require('./components/basic/text-field').default
       ,'textPopup': require('./components/basic/text-popup').default
       ,'videoPopup': require('./components/basic/video-popup').default
       ,'webcam': require('./components/basic/webcam').default
        };
      if (null != components[componentName]) resolve(components[componentName]);
      else reject("invalid component's name");
    } else if ("payment" == section) {
      const components = {
        'creditCardEntry': require('./components/payment/credit-card-entry').default
       ,'invoiceTable': require('./components/payment/invoice-table').default
       ,'selectPayment': require('./components/payment/select-payment').default
        };
      if (null != components[componentName]) resolve(components[componentName]);
      else reject("invalid component's name");
    } else if ("swidget" == section) {
      const components = {
        'imageItem': require('./components/swidget/image-item').default
       ,'smileys': require('./components/swidget/smileys').default
       ,'stars': require('./components/swidget/stars').default
        };
      if (null != components[componentName]) resolve(components[componentName]);
      else reject("invalid component's name");
    } else if ("target-market" == section) {
      const components = {
        'sampleSize': require('./components/target-market/sample-size').default
        };
      if (null != components[componentName]) resolve(components[componentName]);
      else reject("invalid component's name");
    } else reject("invalid component's name");
  });
}

export function getImmutableLib() {
  return require('immutable');
}

export function getJisonLib() {
  return require('@ts-jison/parser-generator');
}

export function getMomentLib() {
  return require('moment');
}

export function getReact() {
  return require('react');
}

export function getReactDOM() {
  return require('react-dom');
}

export function getHtmlToImage() {
  return require('html-to-image');
}

export function renderComponent(componentClassOrName, props, el) {
  return new Promise( (resolve, reject) => {
    if (null == componentClassOrName) { reject('component not specified'); return; }    
    if (null == el)                   { reject('element not specified');   return; }
    const React    = require('react');
    const ReactDOM = require('react-dom');
    const doRender = (componentClass) => {
      const element = React.createElement(componentClass, props);
      ReactDOM.render(element, el);
      resolve(element);
    };
    if ("string" == typeof componentClassOrName) {
      getComponent(componentClassOrName)
        .then((componentClass) => doRender(componentClass))
        .catch((reason) => reject(reason));
    } else doRender(componentClassOrName);
  });
}

export function unlinkComponent(element) {
  return new Promise( (resolve, reject) => {
    const ReactDOM = require('react-dom');
    if (null == element) { reject('element not specified'); return; }
    resolve( ReactDOM.unmountComponentAtNode(element) );
  });
}

export function listComponents() {
  return new Promise( (resolve, reject) => {
    resolve({
      'advanced': ['autocomplete', 'colorComplex', 'colorPalette', 'colorPickerPopup', 'colorPicker', 'dateRangePicker', 'dateTimePicker', 'imageGallery', 'pagination', 'rangeSlider', 'richTextCounter', 'richText', 'slider', 'surveyAddonEstimator', 'surveyEstimator', 'tabbedSidebar', 'tagsList', 'toggle', 'tutorialVideoList', 'tutorialVideo']
     ,'assets': ['assetFilesUploader', 'uploadAssetsButton']
     ,'basic': ['autosizedInput', 'button', 'checkBox', 'clickOutside', 'clickTarget', 'clickTarget.test', 'dropdownMenu', 'dropdownMenu.test', 'dropdown', 'formattedInput', 'hoverTarget', 'imagePin', 'imagePopup', 'inlineSearch', 'inlineSelect', 'label', 'lightBox', 'loaderDots', 'loaderWave', 'maskedInput', 'materialTextField', 'multiSelect', 'pagination', 'popup', 'portal', 'radioButton', 'rolldown', 'scrollBar', 'select', 'staticBlock', 'textField', 'textPopup', 'videoPopup', 'webcam']
     ,'payment': ['creditCardEntry', 'invoiceTable', 'selectPayment']
     ,'swidget': ['imageItem', 'smileys', 'stars']
     ,'target-market': ['sampleSize']
    });
  });
}

if ("undefined" != typeof window) {
  window['$RFDUI'] || (window['$RFDUI'] = {});

  window['$RFDUI']['getComponent']    = getComponent;
  window['$RFDUI']['renderComponent'] = renderComponent;
  window['$RFDUI']['getImmutableLib'] = getImmutableLib;
  window['$RFDUI']['getJisonLib'] = getJisonLib;
  window['$RFDUI']['getMomentLib'] = getMomentLib;
  window['$RFDUI']['getReact'] = getReact;
  window['$RFDUI']['getReactDOM'] = getReactDOM;
  window['$RFDUI']['unlinkComponent'] = unlinkComponent;
  window['$RFDUI']['listComponents']  = listComponents;

  window['$HTMLTOIMAGE'] = getHtmlToImage;
}
